<template>
  <div class="wrapper">
    <div v-loading="loading" class="basic-setting">
      <Top title="基础设置">
      </Top>
      <el-form
        ref="ruleForm"
        class="form"
        label-width="90px"
        :rules="rules"
        :model="form">
        <el-form-item
          label="系统名称"
          prop="systemName">
          <el-input v-model="form.systemName" placeholder="请填写" :maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="系统logo" prop="systemLogo">
          <Single v-model="form.systemLogo" :max-size="500*1024"></Single>
        </el-form-item>
        <el-form-item label="登录页图片" prop="systemLoginBackground">
          <Single v-model="form.systemLoginBackground" class="img-box" :max-size="2*1024*1024"></Single>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Top from '@/components/common/tableTop'
import Single from '../../../components/imageUpload/single.vue'
import {
  getSystemInfoApi,
  updateSystemInfoApi,
} from './fetch'
export default {
  name: 'BasicSetting',
  components: {
    Top,
    Single,
  },
  data () {
    return {
      loading: false,
      form: {
        systemName: '',
        systemLogo: '',
        systemLoginBackground: '',
      },
      rules: {
        systemName: [
          { required: true, message: '请输入', trigger: ['change', 'blur'] },
        ],
      },
      btnLoading: false,
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      try {
        this.loading = true
        const res = await getSystemInfoApi()
        this.form = res
        this.$store.commit('system/SET_SYSTEM_INFO', { ...this.form })
      } catch (e) {
        this.$error(e)
      } finally {
        this.loading = false
      }
    },
    async handleSubmit () {
      try {
        await this.$refs.ruleForm.validate()
        this.btnLoading = true
        await updateSystemInfoApi(this.form)
        this.$success('操作成功')
        this.init()
      } catch (e) {
        this.$error(e)
      } finally {
        this.btnLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper{
  overflow: auto;
}
.basic-setting{
  color: #1C1C1C;
  padding: 0 40px 40px;
  ::v-deep .el-form{
    .el-form-item{
      margin-bottom: 20px;
      .el-input{
        width: 360px;
        .el-input__inner{
          height: 36px;
          line-height: 36px;
        }
      }
    }
  }
}
</style>
